/*========================================
        Imports!!!
=========================================*/

/*--BrowserRouter and react components--*/

import { useNavigate, generatePath } from 'react-router-dom';
import { useEffect, useState } from 'react';

/*--css--*/
import Header from './header.js';
import Footer from './footer.js';
import '../assets/css/blog.css';
import 'bootstrap/dist/css/bootstrap.min.css';
import Row from 'react-bootstrap/Row';
import Col from 'react-bootstrap/Col';


/*--image shorts--*/

import short1 from '../assets/shortsImg/short6.webp';
import short2 from '../assets/shortsImg/short4.webp';
import short3 from '../assets/shortsImg/short1.webp';
import short4 from '../assets/shortsImg/short3.webp';
import short5 from '../assets/shortsImg/short5.webp';
import short6 from '../assets/shortsImg/short2.webp';

/*========================================
        Buttons and navigation!!!
=========================================*/


function ClickButton({ onSelect }) {
  return (
    <>
      <section className='Buttonsy'>
        {/*--button--*/}
        <button onClick={() => onSelect(1)}  reloaddocument ="true" id="szorcik1">
          <Row className='Post'>
            <Col lg={4} md={6} xs={12}>
              <img src={short1} alt='ciekawostka' className='ZdjWPoscie' id="short1"/>
            </Col>
            <Col lg={8} md={6} xs={12} className='postText'>
              <h3>Skąd wzięła się pierwsza apteczka?</h3>
              <p>Nie zgadniesz, kto i po co ją wymyślił. To miało ratować nie życie, a czas pracy.</p>
            </Col>
          </Row>
        </button>
        {/*--button--*/}
        <button onClick={() => onSelect(2)} reloaddocument ="true" id="szorcik2">
          <Row className='Post'>
            <Col lg={4} md={6} xs={12}>
              <img src={short2} alt='ciekawostka' className='ZdjWPoscie' id="short2"/>
            </Col>
            <Col lg={8} md={6} xs={12} className='postText'>
              <h3>Czy AED naprawdę myśli za człowieka?</h3>
              <p>Urządzenie, które może uratować życie nawet jeśli nie wiesz, jak go użyć.</p>
            </Col>
          </Row>
        </button>
        {/*--button--*/}
        <button onClick={() => onSelect(3)} reloaddocument ="true">
          <Row className='Post'>
            <Col lg={4} md={6} xs={12}>
              <img src={short3} alt='ciekawostka' className='ZdjWPoscie' id="short3"/>
            </Col>
            <Col lg={8} md={6} xs={12} className='postText'>
              <h3>Maseczka chirurgiczna nie chroniła lekarza?</h3>
              <p>Poznasz zaskakujące początki najczęściej noszonego sprzętu medycznego ostatnich lat.</p>
            </Col>
          </Row>
        </button>
        {/*--button--*/}
        <button onClick={() => onSelect(4)} reloaddocument ="true">
          <Row className='Post'>
            <Col lg={4} md={6} xs={12}>
              <img src={short4} alt='ciekawostka' className='ZdjWPoscie' id="short4"/>
            </Col>
            <Col lg={8} md={6} xs={12} className='postText'>
              <h3>Po co gaśnica w przychodni?</h3>
              <p>To nie przypadek! Dowiedz się, dlaczego w medycynie liczy się nawet rodzaj proszku.</p>
            </Col>
          </Row>
        </button>
        {/*--button--*/}
        <button onClick={() => onSelect(5)} reloaddocument ="true">
          <Row className='Post'>
            <Col lg={4} md={6} xs={12}>
              <img src={short5} alt='ciekawostka' className='ZdjWPoscie' id="short5"/>
            </Col>
            <Col lg={8} md={6} xs={12} className='postText'>
              <h3>Koc, który nie grzeje, a ratuje życie</h3>
              <p>Wydaje się zwykły i cienki, ale w ekstremalnych warunkach może zrobić ogromną różnicę.</p>
            </Col>
          </Row>
        </button>
        {/*--button--*/}
        <button onClick={() => onSelect(6)} reloaddocument ="true">
          <Row className='Post'>
            <Col lg={4} md={6} xs={12}>
              <img src={short6} alt='ciekawostka' className='ZdjWPoscie' id="short6"/>
            </Col>
            <Col lg={8} md={6} xs={12} className='postText'>
              <h3>Rękawiczki jednorazowe wynaleziono z miłości!</h3>
              <p>Ta historia zaczyna się na sali operacyjnej i kończy w… sercu.</p>
            </Col>
          </Row>
        </button>
      </section>
    </>
  );

}


function Send() {
  const navigate = useNavigate();
  const [selectedNumber, setSelected] = useState(null);

  useEffect(() => {
    if (selectedNumber !== null) {
      const path = generatePath("/story/:id", { id: selectedNumber });
      navigate(path);
    }
    
  },[selectedNumber, navigate])

  return (
    <>
      <section className='send'>
        <section className='posts'>
          <ClickButton onSelect={setSelected}/>
        </section>
      </section>
    </>
  );

}

function Blog() {
    return (
      <>  
        <Header />
        <Send/>
        <Footer/>
      </>
    );
}

export default Blog;